import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';

export default {
  componentWrapper: css`
    label: navigationSectionDesktop__componentWrapper;
    display: flex;
    padding: ${spacing.S} 0 ${spacing.M} 0;
    width: 100%;
  `,
  cardWrapper: css`
    label: navigationSectionDesktop__cardWrapper;
    width: 30rem;
    padding: 0;
    border-radius: 1.6rem;
    background-color: ${colours.background.SECTION};
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  `,
  columns: css`
    label: navigationSectionDesktop__columns;
    flex: 1;
    padding: 0 ${spacing.S};
  `,
};
